export const saveMatchedUser = (user) =>(dispatch)=>{
        dispatch({
            type:'MATCHED_USERS',
            payload:user
        })

}